import React from "react";
import PropTypes from "prop-types";

export const FeedCardHeaderDate = ({ children = null, className = "" }) => (
  <div className={`media__content ${className}`}>{children}</div>
);

FeedCardHeaderDate.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default FeedCardHeaderDate;
